// MexiHome5 — translations PT / EN / FR / ES
export const SUPPORTED_LANGS = [
  { code: "pt", flag: "🇵🇹", label: "PT" },
  { code: "en", flag: "🇬🇧", label: "EN" },
  { code: "fr", flag: "🇫🇷", label: "FR" },
  { code: "es", flag: "🇪🇸", label: "ES" },
  { code: "de", flag: "🇩🇪", label: "DE" },
];

export const translations = {
  pt: {
    nav: { gallery: "Galeria", amenities: "Comodidades", neighborhood: "Vizinhança", booking: "Reserva", about: "Sobre", reviews: "Avaliações", cta: "Pedir Orçamento" },
    availability: "Agenda abre em Julho 2026 · pré-reservas aceites com prioridade",
    hero: {
      badge: "Alojamento Local · Mexilhoeira Grande",
      title1: "O seu refúgio",
      title2: "no Algarve",
      subtitle: "Casa de charme em Mexilhoeira Grande,",
      subtitle2: "a 10 min de Portimão e 20 min de Lagos.",
      address: "Rua Valeriano João da Glória, Nº 5 · Mexilhoeira Grande, 8500-132",
      pricetag: "Reserva direta = melhor preço garantido",
      cta: "Pedir Orçamento",
      gallery: "Ver Galeria",
    },
    hosts: { eyebrow: "Os seus anfitriões:", names: "Carlos & Rute", description: "Disponíveis para qualquer dúvida ou emergência. WhatsApp disponível." },
    bannerPreco: {
      title: "Reserve diretamente e poupe",
      subtitle: "Sem comissões. Melhor preço sempre aqui, com atenção personalizada de Carlos & Rute.",
      bullets: ["Sem taxas de serviço", "Contacto direto com anfitriões", "Flexibilidade total", "Resposta rápida"],
    },
    amenities: {
      eyebrow: "O que tem a casa",
      title1: "Comodidades para",
      title2: "umas férias perfeitas",
      items: {
        jacuzzi: { t: "Jacuzzi", d: "Jacuzzi privativo no quintal, com hidromassagem aquecida. Para relaxar ao fim da tarde, depois da praia." },
        ac: { t: "Ar Condicionado", d: "Comando no quarto. Modo Frio (Cool) e Calor (Heat). Desligar sempre ao sair." },
        wifi: { t: "Wi-Fi Alta Velocidade", d: "Rede: MexiHome5_Guest — ligação rápida em toda a casa." },
        tv: { t: "Smart TV", d: "Smart TV no quarto com acesso a plataformas de streaming. Comando na mesa de cabeceira." },
        coffee: { t: "Máquina de Café", d: "Cápsulas no armário de cima. Ligar → luz verde → inserir cápsula → pressionar." },
        kitchen: { t: "Cozinha Equipada", d: "Cozinha completa. O Coviran fica a apenas 80m para as compras do dia a dia." },
        parking: { t: "Estacionamento", d: "Estacionamento gratuito na rua, mesmo à porta da casa. Sem preocupações na chegada." },
        checkout: { t: "Check-out Fácil", d: "Check-out até às 11:00. Chaves no cofre junto à entrada. Saídas tardias com aviso." },
        pets: { t: "Animais de Estimação", d: "Aceites com autorização prévia. Indicar sempre no momento da reserva." },
      },
      rules: { title: "Regras da Casa", items: ["🔇 Silêncio após as 22:00", "🚭 Proibido fumar no interior", "👥 Só hóspedes registados pernoitam", "🐾 Animais apenas com autorização prévia"] },
      recycling: { title: "Reciclagem (Rua A)", items: ["Azul → papel", "Amarelo → plástico/metal", "Verde → vidro", "Preto → indiferenciado"] },
    },
    gallery: { eyebrow: "A casa", title: "Rua Valeriano João da Glória,", title2: "Nº 5", cta: "Reservar agora", note: "Fotos provisórias das primeiras divisões — a galeria completa ficará disponível com a abertura em Julho.", construction: "Em Preparação" },
    distances: { eyebrow: "Localização", title1: "Tudo perto de", title2: "si", subtitle: "Do supermercado à praia, das padarias aos restaurantes, tudo a poucos passos ou minutos de carro." },
    neighborhood: { eyebrow: "A pé da porta", title1: "Mexilhoeira Grande", title2: "tem tudo perto" },
    restaurants: {
      eyebrow: "Dicas de Carlos & Rute",
      title1: "Restaurantes",
      title2: "recomendados",
      reservation: "Reserva obrigatória",
      lunch: "Almoços",
      goodPrice: "Bom preço",
    },
    booking: {
      eyebrow: "Reserva direta",
      title1: "Pedir",
      title2: "orçamento",
      subtitle: "Preencha o formulário e Carlos ou Rute respondem em menos de 24 horas com o preço personalizado para a sua estadia.",
      highlights: [
        { t: "Melhor preço garantido", d: "Sem comissões — poupa até 15% vs plataformas." },
        { t: "Fala com Carlos & Rute", d: "Contacto direto com os anfitriões. Sem intermediários." },
        { t: "Check-out até às 11:00", d: "Saídas tardias negociáveis com aviso prévio." },
        { t: "Resposta rápida", d: "Carlos: 965 209 781 · Rute: 965 488 960 · WhatsApp ✓" },
      ],
      form: {
        title: "Pedido de Orçamento",
        subtitle: "Sem compromisso · Resposta em <24h por Carlos ou Rute",
        dates: "Datas da estadia",
        datesPlaceholder: "Selecionar check-in → check-out",
        nightsHint: "Mínimo 3 noites · máximo 31",
        adults: "Pessoas",
        babies: "Bebés (até 3 anos)",
        maxAdults: "Máximo 6 pessoas",
        maxBabies: "Máximo 2 bebés",
        name: "Nome",
        namePlaceholder: "O seu nome",
        email: "Email",
        emailPlaceholder: "email@exemplo.com",
        message: "Mensagem (opcional)",
        messagePlaceholder: "Animais, pedidos especiais, comentários…",
        submit: "Enviar Pedido de Orçamento",
        sending: "A enviar…",
        select: "— selecionar —",
        adult: "pessoa", adults_p: "pessoas", baby: "bebé", babies_p: "bebés", max: "(máx.)",
      },
      toast: { needDates: "Selecione as datas de check-in e check-out.", minNights: "A estadia mínima é de 3 noites.", maxNights: "A estadia máxima é de 31 noites.", needAdults: "Indique o número de pessoas.", needNameEmail: "Preencha o seu nome e email.", success: "Pedido enviado! Carlos ou Rute respondem em <24h. 🙏", error: "Não foi possível enviar. Tente de novo." },
    },
    reviews: { eyebrow: "O que dizem os hóspedes", title1: "Opiniões sobre o", title2: "MexiHome5",
      empty: { title: "As primeiras opiniões estão a caminho", body: "A casa abre em Julho de 2026 — sê dos primeiros a viver a experiência e a partilhar a tua opinião honesta. Nada de comentários falsos: aqui só verdade.", cta: "Quero ser dos primeiros" }
    },
    embreve: {
      badge: "Em breve · Julho 2026",
      title1: "A casa está a ser",
      title2: "preparada com amor",
      subtitle: "Estamos a dar os últimos retoques para receber os primeiros hóspedes em Julho de 2026. Reserva a tua data com prioridade — agradecemos a tua paciência.",
      hint: "Pré-reservas aceites · resposta em <24h",
      cta: "Reservar com prioridade",
      days: "Dias", hours: "Horas", minutes: "Min", seconds: "Seg"
    },
    segredos: {
      eyebrow: "De Carlos & Rute",
      title1: "Segredos",
      title2: "locais",
      subtitle: "Pequenos prazeres e lugares secretos que tornam cada estadia única — e algumas surpresas que estão a caminho.",
      items: [
        { tag: "A surpresa revelada", t: "Jacuzzi no quintal", d: "A novidade que estávamos a preparar já cá está. Jacuzzi privativo no quintal, águas aquecidas com hidromassagem — perfeito para acabar o dia debaixo do céu do Algarve, em recato e sem pressas." },
        { tag: "Dica secreta", t: "Melhor Pôr-do-Sol", d: "A Ria de Alvor ao entardecer é de cortar a respiração — reflexos dourados sobre o estuário. Vá pelos Passadiços perto das 19h (no verão). O Forte de Alvor com vista para o mar é outra opção incrível." },
        { tag: "Vale a viagem", t: "Silves Vale a Viagem", d: "A 25 min. Castelo mouro medieval e catedral gótica. O Festival Medieval em julho/agosto é um evento único na Europa. Reserve alojamento em Silves nesse fim de semana." },
        { tag: "Sabores", t: "Produtos Regionais", d: "Não saia sem provar medronho! Também: figos secos algarvios, amêndoa torrada e mel de urze de Monchique. Mercado de Portimão aos sábados de manhã." },
      ],
    },
    footer: {
      tagline: "O seu refúgio no coração de Mexilhoeira Grande. Casa de charme com a hospitalidade pessoal de Carlos & Rute Simões. Reserva direta sempre ao melhor preço.",
      contacts: "Contactos",
      address: "Morada",
      rights: "Todos os direitos reservados",
      madeIn: "Feito com ♥ em Mexilhoeira Grande, Algarve",
      followUs: "Acompanhe-nos",
      followTitle1: "Siga a casa",
      followTitle2: "no Instagram & Facebook",
      followSubtitle: "Veja em primeira mão os bastidores da preparação, as novidades e o dia-a-dia em Mexilhoeira Grande. Escaneie o QR code com a câmara do telemóvel.",
    },
    whatsapp: { open: "Falar pelo WhatsApp", title: "Olá! 👋", subtitle: "Como prefere falar connosco?", carlos: "Falar com o Carlos", rute: "Falar com a Rute", greeting: "Olá! Tenho interesse em reservar a MexiHome5." },
    about: {
      hero: { eyebrow: "Início › Sobre", title1: "A nossa casa", title2: "& localização", subtitle: "Conheça a MexiHome5, os seus anfitriões Carlos & Rute, as praias, restaurantes e dicas secretas do Algarve." },
      story: {
        eyebrow: "A nossa história",
        welcome: "Bem-vindos ao",
        body1: "É com grande prazer que recebemos os nossos hóspedes no MexiHome5. Esta é a vossa casa durante a estadia — façam-se à vontade para explorar, descansar e descobrir tudo o que o Algarve tem para oferecer.",
        body2: "Situada na Rua Valeriano João da Glória, Nº 5, em Mexilhoeira Grande, a casa combina o charme tradicional algarvio com o conforto moderno. A 10 minutos de Portimão, 12 da Praia de Alvor e 20 de Lagos — tranquila para descansar, perto de tudo o que importa.",
        body3: "Quando reserva diretamente connosco, tem o melhor preço garantido, comunicação direta com os anfitriões e uma experiência personalizada que as plataformas não conseguem dar.",
        metrics: [ { v: "6", l: "Hóspedes máx." }, { v: "2", l: "Quartos" }, { v: "1", l: "WC" }, { v: "120m²", l: "Área aprox." } ],
        license: "Alojamento Local",
      },
      hosts: {
        eyebrow: "Quem vos recebe",
        title1: "Os vossos",
        title2: "anfitriões",
        cards: {
          carlos: { tag: "Anfitrião principal", desc: "Disponível para qualquer dúvida ou emergência. WhatsApp disponível." },
          rute: { tag: "Anfitriã", desc: "Contacto alternativo. WhatsApp disponível. Para check-in tardio e pedidos especiais." },
          email: { tag: "Email", desc: "Para reservas, orçamentos, check-in tardio ou pedidos especiais.", cta: "Enviar email" },
          sos: { tag: "Emergências", desc: "Emergências gerais em Portugal.", cta: "Ligar agora" },
          hospital: { tag: "Hospital Portimão", desc: "Urgências médicas · 24 horas · a 10 min da casa.", cta: "Ligar agora" },
          farmacia: { tag: "Farmácia", desc: "Mexilhoeira Grande · ~300m. Para urgências menores." },
        },
      },
      map: { eyebrow: "Localização", title1: "Mexilhoeira Grande,", title2: "Algarve", addressLabel: "Morada exata", distancesLabel: "Distâncias", openMap: "Abrir no Google Maps", walk: "a pé" },
    },
  },
  en: {
    nav: { gallery: "Gallery", amenities: "Amenities", neighborhood: "Neighborhood", booking: "Booking", about: "About", reviews: "Reviews", cta: "Get a Quote" },
    availability: "Calendar opens in July 2026 · pre-bookings welcomed with priority",
    hero: {
      badge: "Local Lodging · Mexilhoeira Grande",
      title1: "Your refuge",
      title2: "in the Algarve",
      subtitle: "A charming house in Mexilhoeira Grande,",
      subtitle2: "10 min from Portimão and 20 min from Lagos.",
      address: "Rua Valeriano João da Glória, Nº 5 · Mexilhoeira Grande, 8500-132",
      pricetag: "Direct booking = best price guaranteed",
      cta: "Get a Quote",
      gallery: "View Gallery",
    },
    hosts: { eyebrow: "Your hosts:", names: "Carlos & Rute", description: "Available for any question or emergency. WhatsApp available." },
    bannerPreco: {
      title: "Book directly and save",
      subtitle: "No commissions. Best price always here, with personal attention from Carlos & Rute.",
      bullets: ["No service fees", "Direct contact with hosts", "Full flexibility", "Quick response"],
    },
    amenities: {
      eyebrow: "What the house offers",
      title1: "Amenities for",
      title2: "a perfect holiday",
      items: {
        jacuzzi: { t: "Jacuzzi", d: "Private jacuzzi in the patio, with heated hydromassage. Perfect to unwind in the late afternoon, after the beach." },
        ac: { t: "Air Conditioning", d: "Remote in the bedroom. Cool & Heat modes. Always turn off when leaving." },
        wifi: { t: "High-Speed Wi-Fi", d: "Network: MexiHome5_Guest — fast connection throughout the house." },
        tv: { t: "Smart TV", d: "Smart TV in the bedroom with access to streaming platforms. Remote on the nightstand." },
        coffee: { t: "Coffee Machine", d: "Capsules in the upper cabinet. Power on → green light → insert capsule → press." },
        kitchen: { t: "Fully Equipped Kitchen", d: "Complete kitchen. Coviran supermarket is just 80m away for daily shopping." },
        parking: { t: "Parking", d: "Free street parking right at the door. No worries on arrival." },
        checkout: { t: "Easy Check-out", d: "Check-out by 11:00. Keys in the lockbox at the entrance. Late checkout with notice." },
        pets: { t: "Pets", d: "Accepted with prior authorisation. Always indicate at the time of booking." },
      },
      rules: { title: "House Rules", items: ["🔇 Quiet after 22:00", "🚭 No smoking indoors", "👥 Registered guests only overnight", "🐾 Pets only with prior approval"] },
      recycling: { title: "Recycling (Street A)", items: ["Blue → paper", "Yellow → plastic/metal", "Green → glass", "Black → general waste"] },
    },
    gallery: { eyebrow: "The house", title: "Rua Valeriano João da Glória,", title2: "Nº 5", cta: "Book now", note: "Provisional photos of the first rooms — full gallery available when we open in July.", construction: "Under Preparation" },
    distances: { eyebrow: "Location", title1: "Everything close to", title2: "you", subtitle: "From the supermarket to the beach, bakeries to restaurants — all within a few steps or a short drive." },
    neighborhood: { eyebrow: "On foot from the door", title1: "Mexilhoeira Grande", title2: "has it all nearby" },
    restaurants: {
      eyebrow: "Tips from Carlos & Rute",
      title1: "Recommended",
      title2: "restaurants",
      reservation: "Reservation required",
      lunch: "Lunches",
      goodPrice: "Great value",
    },
    booking: {
      eyebrow: "Direct booking",
      title1: "Request a",
      title2: "quote",
      subtitle: "Fill in the form and Carlos or Rute will reply within 24 hours with a personalised price for your stay.",
      highlights: [
        { t: "Best price guaranteed", d: "No commissions — save up to 15% vs platforms." },
        { t: "Talk to Carlos & Rute", d: "Direct contact with the hosts. No middlemen." },
        { t: "Check-out by 11:00", d: "Late check-outs negotiable with prior notice." },
        { t: "Quick response", d: "Carlos: 965 209 781 · Rute: 965 488 960 · WhatsApp ✓" },
      ],
      form: {
        title: "Quote Request",
        subtitle: "No commitment · Reply in <24h from Carlos or Rute",
        dates: "Stay dates",
        datesPlaceholder: "Select check-in → check-out",
        nightsHint: "Minimum 3 nights · maximum 31",
        adults: "People",
        babies: "Babies (up to 3)",
        maxAdults: "Maximum 6 people",
        maxBabies: "Maximum 2 babies",
        name: "Name",
        namePlaceholder: "Your name",
        email: "Email",
        emailPlaceholder: "email@example.com",
        message: "Message (optional)",
        messagePlaceholder: "Pets, special requests, comments…",
        submit: "Send Quote Request",
        sending: "Sending…",
        select: "— select —",
        adult: "person", adults_p: "people", baby: "baby", babies_p: "babies", max: "(max.)",
      },
      toast: { needDates: "Please select check-in and check-out dates.", minNights: "The minimum stay is 3 nights.", maxNights: "The maximum stay is 31 nights.", needAdults: "Please indicate the number of people.", needNameEmail: "Please fill in your name and email.", success: "Request sent! Carlos or Rute will reply within 24h. 🙏", error: "Unable to send. Please try again." },
    },
    reviews: { eyebrow: "What guests say", title1: "Reviews of", title2: "MexiHome5",
      empty: { title: "The first reviews are on the way", body: "The house opens in July 2026 — be one of the first guests to live the experience and share your honest review. No fake comments: only the real thing.", cta: "I want to be among the first" }
    },
    embreve: {
      badge: "Coming soon · July 2026",
      title1: "The house is being",
      title2: "prepared with love",
      subtitle: "We're putting the final touches in place to welcome the first guests in July 2026. Reserve your dates with priority — thank you for your patience.",
      hint: "Pre-bookings accepted · reply within 24h",
      cta: "Reserve with priority",
      days: "Days", hours: "Hours", minutes: "Min", seconds: "Sec"
    },
    segredos: {
      eyebrow: "From Carlos & Rute",
      title1: "Local",
      title2: "secrets",
      subtitle: "Little pleasures and secret spots that make every stay unique — and a few surprises on their way.",
      items: [
        { tag: "Surprise revealed", t: "Jacuzzi in the patio", d: "The surprise we were preparing is here. Private jacuzzi in the patio with heated hydromassage waters — perfect to end the day under the Algarve sky, in privacy and without rush." },
        { tag: "Secret tip", t: "Best Sunset", d: "The Alvor Estuary at dusk is breathtaking — golden reflections over the water. Head to the Passadiços around 7pm (summer). Forte de Alvor overlooking the sea is another stunning option." },
        { tag: "Worth the trip", t: "Silves Is Worth It", d: "25 min away. Moorish medieval castle and Gothic cathedral. The Medieval Festival in July/August is a unique event in Europe. Book a stay in Silves that weekend." },
        { tag: "Flavours", t: "Regional Products", d: "Don't leave without trying medronho! Also: Algarvian dried figs, roasted almonds and Monchique heather honey. Portimão Market on Saturday mornings." },
      ],
    },
    footer: {
      tagline: "Your refuge in the heart of Mexilhoeira Grande. A charming house with the personal hospitality of Carlos & Rute Simões. Direct booking, always the best price.",
      contacts: "Contacts",
      address: "Address",
      rights: "All rights reserved",
      madeIn: "Made with ♥ in Mexilhoeira Grande, Algarve",
      followUs: "Follow us",
      followTitle1: "Follow the house",
      followTitle2: "on Instagram & Facebook",
      followSubtitle: "See behind-the-scenes of the preparation, news and daily life in Mexilhoeira Grande. Scan the QR code with your phone camera.",
    },
    whatsapp: { open: "Chat on WhatsApp", title: "Hello! 👋", subtitle: "How would you prefer to talk to us?", carlos: "Chat with Carlos", rute: "Chat with Rute", greeting: "Hi! I'm interested in booking MexiHome5." },
    about: {
      hero: { eyebrow: "Home › About", title1: "Our house", title2: "& location", subtitle: "Meet MexiHome5, your hosts Carlos & Rute, the beaches, restaurants and secret tips of the Algarve." },
      story: {
        eyebrow: "Our story",
        welcome: "Welcome to",
        body1: "It is with great pleasure that we welcome our guests at MexiHome5. This is your home during your stay — feel free to explore, relax and discover all that the Algarve has to offer.",
        body2: "Located at Rua Valeriano João da Glória, Nº 5, in Mexilhoeira Grande, the house combines traditional Algarvian charm with modern comfort. 10 minutes from Portimão, 12 from Alvor Beach and 20 from Lagos — quiet for resting, close to everything that matters.",
        body3: "When you book directly with us, you get the best price guaranteed, direct communication with the hosts, and a personalised experience that platforms cannot provide.",
        metrics: [ { v: "6", l: "Max guests" }, { v: "2", l: "Bedrooms" }, { v: "1", l: "Bathroom" }, { v: "120m²", l: "Approx. area" } ],
        license: "Local Lodging",
      },
      hosts: {
        eyebrow: "Who welcomes you",
        title1: "Your",
        title2: "hosts",
        cards: {
          carlos: { tag: "Main host", desc: "Available for any question or emergency. WhatsApp available." },
          rute: { tag: "Host", desc: "Alternative contact. WhatsApp available. For late check-in and special requests." },
          email: { tag: "Email", desc: "For bookings, quotes, late check-in or special requests.", cta: "Send email" },
          sos: { tag: "Emergencies", desc: "General emergencies in Portugal.", cta: "Call now" },
          hospital: { tag: "Portimão Hospital", desc: "Medical emergencies · 24 hours · 10 min from the house.", cta: "Call now" },
          farmacia: { tag: "Pharmacy", desc: "Mexilhoeira Grande · ~300m. For minor emergencies." },
        },
      },
      map: { eyebrow: "Location", title1: "Mexilhoeira Grande,", title2: "Algarve", addressLabel: "Exact address", distancesLabel: "Distances", openMap: "Open in Google Maps", walk: "on foot" },
    },
  },
  fr: {
    nav: { gallery: "Galerie", amenities: "Commodités", neighborhood: "Quartier", booking: "Réservation", about: "À propos", reviews: "Avis", cta: "Demander un devis" },
    availability: "Le calendrier ouvre en juillet 2026 · pré-réservations acceptées en priorité",
    hero: {
      badge: "Hébergement local · Mexilhoeira Grande",
      title1: "Votre refuge",
      title2: "en Algarve",
      subtitle: "Maison de charme à Mexilhoeira Grande,",
      subtitle2: "à 10 min de Portimão et 20 min de Lagos.",
      address: "Rua Valeriano João da Glória, Nº 5 · Mexilhoeira Grande, 8500-132",
      pricetag: "Réservation directe = meilleur prix garanti",
      cta: "Demander un devis",
      gallery: "Voir la galerie",
    },
    hosts: { eyebrow: "Vos hôtes :", names: "Carlos & Rute", description: "Disponibles pour toute question ou urgence. WhatsApp disponible." },
    bannerPreco: {
      title: "Réservez directement et économisez",
      subtitle: "Sans commissions. Toujours le meilleur prix ici, avec l'attention personnalisée de Carlos & Rute.",
      bullets: ["Sans frais de service", "Contact direct avec les hôtes", "Flexibilité totale", "Réponse rapide"],
    },
    amenities: {
      eyebrow: "Ce qu'offre la maison",
      title1: "Commodités pour",
      title2: "des vacances parfaites",
      items: {
        jacuzzi: { t: "Jacuzzi", d: "Jacuzzi privé dans le patio, avec hydromassage chauffé. Idéal pour se détendre en fin de journée, après la plage." },
        ac: { t: "Climatisation", d: "Télécommande dans la chambre. Modes Froid et Chaud. Éteindre en partant." },
        wifi: { t: "Wi-Fi haut débit", d: "Réseau : MexiHome5_Guest — connexion rapide dans toute la maison." },
        tv: { t: "Smart TV", d: "Smart TV avec accès aux plateformes de streaming. Télécommande sur la table de nuit." },
        coffee: { t: "Machine à café", d: "Capsules dans le placard du haut. Allumer → voyant vert → capsule → appuyer." },
        kitchen: { t: "Cuisine équipée", d: "Cuisine complète. Supermarché Coviran à 80 m pour les courses du jour." },
        parking: { t: "Parking", d: "Stationnement gratuit dans la rue, devant la maison. Aucune préoccupation à l'arrivée." },
        checkout: { t: "Départ facile", d: "Départ jusqu'à 11h00. Clés dans le coffre à l'entrée. Départ tardif sur demande." },
        pets: { t: "Animaux", d: "Acceptés avec autorisation préalable. À indiquer lors de la réservation." },
      },
      rules: { title: "Règles de la maison", items: ["🔇 Silence après 22h00", "🚭 Non-fumeur à l'intérieur", "👥 Seuls les invités enregistrés dorment ici", "🐾 Animaux avec autorisation préalable"] },
      recycling: { title: "Recyclage (Rue A)", items: ["Bleu → papier", "Jaune → plastique/métal", "Vert → verre", "Noir → ordures ménagères"] },
    },
    gallery: { eyebrow: "La maison", title: "Rua Valeriano João da Glória,", title2: "Nº 5", cta: "Réserver maintenant", note: "Photos provisoires des premières pièces — galerie complète disponible à l'ouverture en juillet.", construction: "En Préparation" },
    distances: { eyebrow: "Localisation", title1: "Tout près de", title2: "vous", subtitle: "Du supermarché à la plage, des boulangeries aux restaurants — tout à quelques pas ou minutes en voiture." },
    neighborhood: { eyebrow: "À pied depuis la porte", title1: "Mexilhoeira Grande", title2: "a tout à proximité" },
    restaurants: {
      eyebrow: "Conseils de Carlos & Rute",
      title1: "Restaurants",
      title2: "recommandés",
      reservation: "Réservation obligatoire",
      lunch: "Déjeuners",
      goodPrice: "Bon rapport qualité-prix",
    },
    booking: {
      eyebrow: "Réservation directe",
      title1: "Demander un",
      title2: "devis",
      subtitle: "Remplissez le formulaire et Carlos ou Rute répondent en moins de 24 heures avec un prix personnalisé.",
      highlights: [
        { t: "Meilleur prix garanti", d: "Sans commissions — économisez jusqu'à 15 %." },
        { t: "Parlez avec Carlos & Rute", d: "Contact direct avec les hôtes. Sans intermédiaires." },
        { t: "Départ jusqu'à 11h00", d: "Départs tardifs négociables avec préavis." },
        { t: "Réponse rapide", d: "Carlos : 965 209 781 · Rute : 965 488 960 · WhatsApp ✓" },
      ],
      form: {
        title: "Demande de devis",
        subtitle: "Sans engagement · Réponse en <24h par Carlos ou Rute",
        dates: "Dates du séjour",
        datesPlaceholder: "Sélectionner check-in → check-out",
        nightsHint: "Minimum 3 nuits · maximum 31",
        adults: "Personnes",
        babies: "Bébés (jusqu'à 3 ans)",
        maxAdults: "Maximum 6 personnes",
        maxBabies: "Maximum 2 bébés",
        name: "Nom",
        namePlaceholder: "Votre nom",
        email: "Email",
        emailPlaceholder: "email@exemple.com",
        message: "Message (optionnel)",
        messagePlaceholder: "Animaux, demandes spéciales, commentaires…",
        submit: "Envoyer la demande",
        sending: "Envoi en cours…",
        select: "— sélectionner —",
        adult: "personne", adults_p: "personnes", baby: "bébé", babies_p: "bébés", max: "(max.)",
      },
      toast: { needDates: "Sélectionnez les dates de check-in et check-out.", minNights: "Le séjour minimum est de 3 nuits.", maxNights: "Le séjour maximum est de 31 nuits.", needAdults: "Indiquez le nombre de personnes.", needNameEmail: "Remplissez votre nom et email.", success: "Demande envoyée ! Carlos ou Rute répondent sous 24h. 🙏", error: "Envoi impossible. Veuillez réessayer." },
    },
    reviews: { eyebrow: "Ce que disent les hôtes", title1: "Avis sur le", title2: "MexiHome5",
      empty: { title: "Les premiers avis arrivent", body: "La maison ouvre en juillet 2026 — soyez parmi les premiers à vivre l'expérience et à partager votre avis honnête. Pas de faux commentaires : que du vrai.", cta: "Je veux être parmi les premiers" }
    },
    embreve: {
      badge: "Bientôt · Juillet 2026",
      title1: "La maison est",
      title2: "préparée avec amour",
      subtitle: "Nous mettons la dernière main pour accueillir les premiers hôtes en juillet 2026. Réservez vos dates en priorité — merci pour votre patience.",
      hint: "Pré-réservations acceptées · réponse en <24h",
      cta: "Réserver en priorité",
      days: "Jours", hours: "Heures", minutes: "Min", seconds: "Sec"
    },
    segredos: {
      eyebrow: "De Carlos & Rute",
      title1: "Secrets",
      title2: "locaux",
      subtitle: "De petits plaisirs et lieux secrets qui rendent chaque séjour unique — et quelques surprises en chemin.",
      items: [
        { tag: "La surprise dévoilée", t: "Jacuzzi dans le patio", d: "La surprise que nous préparions est enfin là. Jacuzzi privé dans le patio, eaux chauffées avec hydromassage — parfait pour finir la journée sous le ciel de l'Algarve, en toute intimité et sans hâte." },
        { tag: "Astuce secrète", t: "Plus Beau Coucher de Soleil", d: "L'estuaire d'Alvor au crépuscule est à couper le souffle — reflets dorés sur l'eau. Allez sur les Passadiços vers 19h (en été). Le Forte de Alvor avec vue sur la mer est une autre option magnifique." },
        { tag: "Vaut le détour", t: "Silves Vaut le Voyage", d: "À 25 min. Château mauresque médiéval et cathédrale gothique. Le Festival Médiéval en juillet/août est un événement unique en Europe. Réservez un hébergement à Silves ce week-end-là." },
        { tag: "Saveurs", t: "Produits régionaux", d: "Ne partez pas sans goûter le medronho ! Aussi : figues séchées de l'Algarve, amandes grillées et miel de bruyère de Monchique. Marché de Portimão les samedis matin." },
      ],
    },
    footer: {
      tagline: "Votre refuge au cœur de Mexilhoeira Grande. Une maison de charme avec l'hospitalité personnelle de Carlos & Rute Simões. Réservation directe, toujours au meilleur prix.",
      contacts: "Contacts",
      address: "Adresse",
      rights: "Tous droits réservés",
      madeIn: "Fait avec ♥ à Mexilhoeira Grande, Algarve",
      followUs: "Suivez-nous",
      followTitle1: "Suivez la maison",
      followTitle2: "sur Instagram & Facebook",
      followSubtitle: "Découvrez les coulisses de la préparation, les nouveautés et la vie quotidienne à Mexilhoeira Grande. Scannez le QR code avec votre téléphone.",
    },
    whatsapp: { open: "Discuter sur WhatsApp", title: "Bonjour ! 👋", subtitle: "Comment préférez-vous nous parler ?", carlos: "Parler avec Carlos", rute: "Parler avec Rute", greeting: "Bonjour ! Je suis intéressé(e) par MexiHome5." },
    about: {
      hero: { eyebrow: "Accueil › À propos", title1: "Notre maison", title2: "& emplacement", subtitle: "Découvrez MexiHome5, vos hôtes Carlos & Rute, les plages, restaurants et conseils secrets de l'Algarve." },
      story: {
        eyebrow: "Notre histoire",
        welcome: "Bienvenue au",
        body1: "C'est avec grand plaisir que nous accueillons nos hôtes au MexiHome5. C'est votre maison pendant votre séjour — sentez-vous libres d'explorer, de vous reposer et de découvrir tout ce que l'Algarve a à offrir.",
        body2: "Située Rua Valeriano João da Glória, Nº 5, à Mexilhoeira Grande, la maison combine le charme traditionnel algarvien et le confort moderne. À 10 minutes de Portimão, 12 de la plage d'Alvor et 20 de Lagos — tranquille pour se reposer, proche de tout ce qui compte.",
        body3: "Lorsque vous réservez directement avec nous, vous avez le meilleur prix garanti, une communication directe avec les hôtes et une expérience personnalisée que les plateformes ne peuvent pas offrir.",
        metrics: [ { v: "6", l: "Voyageurs max." }, { v: "2", l: "Chambres" }, { v: "1", l: "Salle de bain" }, { v: "120m²", l: "Surface env." } ],
        license: "Hébergement local",
      },
      hosts: {
        eyebrow: "Qui vous accueille",
        title1: "Vos",
        title2: "hôtes",
        cards: {
          carlos: { tag: "Hôte principal", desc: "Disponible pour toute question ou urgence. WhatsApp disponible." },
          rute: { tag: "Hôtesse", desc: "Contact alternatif. WhatsApp disponible. Pour check-in tardif et demandes spéciales." },
          email: { tag: "Email", desc: "Pour réservations, devis, check-in tardif ou demandes spéciales.", cta: "Envoyer un email" },
          sos: { tag: "Urgences", desc: "Urgences générales au Portugal.", cta: "Appeler maintenant" },
          hospital: { tag: "Hôpital de Portimão", desc: "Urgences médicales · 24h/24 · à 10 min de la maison.", cta: "Appeler maintenant" },
          farmacia: { tag: "Pharmacie", desc: "Mexilhoeira Grande · ~300m. Pour urgences mineures." },
        },
      },
      map: { eyebrow: "Localisation", title1: "Mexilhoeira Grande,", title2: "Algarve", addressLabel: "Adresse exacte", distancesLabel: "Distances", openMap: "Ouvrir dans Google Maps", walk: "à pied" },
    },
  },
  es: {
    nav: { gallery: "Galería", amenities: "Comodidades", neighborhood: "Vecindario", booking: "Reserva", reviews: "Opiniones", cta: "Pedir Presupuesto" },
    availability: "El calendario abre en julio 2026 · pre-reservas con prioridad",
    hero: {
      badge: "Alojamiento Local · Mexilhoeira Grande",
      title1: "Tu refugio",
      title2: "en el Algarve",
      subtitle: "Casa con encanto en Mexilhoeira Grande,",
      subtitle2: "a 10 min de Portimão y 20 min de Lagos.",
      address: "Rua Valeriano João da Glória, Nº 5 · Mexilhoeira Grande, 8500-132",
      pricetag: "Reserva directa = mejor precio garantizado",
      cta: "Pedir Presupuesto",
      gallery: "Ver Galería",
    },
    hosts: { eyebrow: "Tus anfitriones:", names: "Carlos & Rute", description: "Disponibles para cualquier duda o emergencia. WhatsApp disponible." },
    bannerPreco: {
      title: "Reserva directamente y ahorra",
      subtitle: "Sin comisiones. Mejor precio siempre aquí, con la atención personalizada de Carlos & Rute.",
      bullets: ["Sin tasas de servicio", "Contacto directo con anfitriones", "Flexibilidad total", "Respuesta rápida"],
    },
    amenities: {
      eyebrow: "Lo que ofrece la casa",
      title1: "Comodidades para",
      title2: "unas vacaciones perfectas",
      items: {
        jacuzzi: { t: "Jacuzzi", d: "Jacuzzi privado en el patio, con hidromasaje climatizado. Perfecto para relajarse al atardecer, después de la playa." },
        ac: { t: "Aire Acondicionado", d: "Mando en la habitación. Modos Frío y Calor. Apagar siempre al salir." },
        wifi: { t: "Wi-Fi de alta velocidad", d: "Red: MexiHome5_Guest — conexión rápida en toda la casa." },
        tv: { t: "Smart TV", d: "Smart TV en la habitación con acceso a plataformas de streaming. Mando en la mesilla." },
        coffee: { t: "Cafetera", d: "Cápsulas en el armario superior. Encender → luz verde → cápsula → pulsar." },
        kitchen: { t: "Cocina equipada", d: "Cocina completa. Supermercado Coviran a sólo 80 m." },
        parking: { t: "Aparcamiento", d: "Aparcamiento gratuito en la calle, junto a la puerta. Sin preocupaciones a la llegada." },
        checkout: { t: "Salida fácil", d: "Salida hasta las 11:00. Llaves en la caja fuerte a la entrada. Salidas tardías con aviso." },
        pets: { t: "Mascotas", d: "Aceptadas con autorización previa. Indicar siempre al reservar." },
      },
      rules: { title: "Normas de la casa", items: ["🔇 Silencio a partir de las 22:00", "🚭 No fumar en el interior", "👥 Sólo huéspedes registrados pernoctan", "🐾 Mascotas sólo con autorización previa"] },
      recycling: { title: "Reciclaje (Calle A)", items: ["Azul → papel", "Amarillo → plástico/metal", "Verde → vidrio", "Negro → resto"] },
    },
    gallery: { eyebrow: "La casa", title: "Rua Valeriano João da Glória,", title2: "Nº 5", cta: "Reservar ahora", note: "Fotos provisionales de las primeras habitaciones — galería completa disponible al abrir en julio.", construction: "En Preparación" },
    distances: { eyebrow: "Localización", title1: "Todo cerca de", title2: "ti", subtitle: "Del supermercado a la playa, panaderías y restaurantes — todo a unos pasos o minutos en coche." },
    neighborhood: { eyebrow: "A pie desde la puerta", title1: "Mexilhoeira Grande", title2: "lo tiene todo cerca" },
    restaurants: {
      eyebrow: "Recomendaciones de Carlos & Rute",
      title1: "Restaurantes",
      title2: "recomendados",
      reservation: "Reserva obligatoria",
      lunch: "Comidas",
      goodPrice: "Buen precio",
    },
    booking: {
      eyebrow: "Reserva directa",
      title1: "Pedir",
      title2: "presupuesto",
      subtitle: "Rellena el formulario y Carlos o Rute responden en menos de 24 horas con el precio personalizado para tu estancia.",
      highlights: [
        { t: "Mejor precio garantizado", d: "Sin comisiones — ahorra hasta un 15 %." },
        { t: "Habla con Carlos & Rute", d: "Contacto directo con los anfitriones. Sin intermediarios." },
        { t: "Salida hasta las 11:00", d: "Salidas tardías negociables con aviso previo." },
        { t: "Respuesta rápida", d: "Carlos: 965 209 781 · Rute: 965 488 960 · WhatsApp ✓" },
      ],
      form: {
        title: "Solicitud de Presupuesto",
        subtitle: "Sin compromiso · Respuesta en <24h por Carlos o Rute",
        dates: "Fechas de la estancia",
        datesPlaceholder: "Seleccionar check-in → check-out",
        nightsHint: "Mínimo 3 noches · máximo 31",
        adults: "Pessoas",
        babies: "Bebés (hasta 3 años)",
        maxAdults: "Máximo 6 pessoas",
        maxBabies: "Máximo 2 bebés",
        name: "Nombre",
        namePlaceholder: "Tu nombre",
        email: "Email",
        emailPlaceholder: "email@ejemplo.com",
        message: "Mensaje (opcional)",
        messagePlaceholder: "Mascotas, peticiones especiales, comentarios…",
        submit: "Enviar Solicitud",
        sending: "Enviando…",
        select: "— seleccionar —",
        adult: "pessoa", adults_p: "pessoas", baby: "bebé", babies_p: "bebés", max: "(máx.)",
      },
      toast: { needDates: "Selecciona las fechas de check-in y check-out.", minNights: "La estancia mínima es de 3 noches.", maxNights: "La estancia máxima es de 31 noches.", needAdults: "Indica el número de personas.", needNameEmail: "Rellena tu nombre y email.", success: "¡Solicitud enviada! Carlos o Rute responden en <24h. 🙏", error: "No se pudo enviar. Inténtalo de nuevo." },
    },
    reviews: { eyebrow: "Lo que dicen los huéspedes", title1: "Opiniones sobre el", title2: "MexiHome5",
      empty: { title: "Las primeras opiniones llegan pronto", body: "La casa abre en julio de 2026 — sé de los primeros en vivir la experiencia y compartir tu opinión sincera. Sin comentarios falsos: solo verdad.", cta: "Quiero ser de los primeros" }
    },
    embreve: {
      badge: "Próximamente · Julio 2026",
      title1: "La casa se está",
      title2: "preparando con amor",
      subtitle: "Estamos dando los últimos toques para recibir a los primeros huéspedes en julio de 2026. Reserva tus fechas con prioridad — gracias por tu paciencia.",
      hint: "Pre-reservas aceptadas · respuesta en <24h",
      cta: "Reservar con prioridad",
      days: "Días", hours: "Horas", minutes: "Min", seconds: "Seg"
    },
    segredos: {
      eyebrow: "De Carlos & Rute",
      title1: "Secretos",
      title2: "locales",
      subtitle: "Pequeños placeres y lugares secretos que hacen única cada estancia — y algunas sorpresas en camino.",
      items: [
        { tag: "La sorpresa revelada", t: "Jacuzzi en el patio", d: "La sorpresa que estábamos preparando ya está aquí. Jacuzzi privado en el patio, aguas climatizadas con hidromasaje — perfecto para terminar el día bajo el cielo del Algarve, en privacidad y sin prisas." },
        { tag: "Consejo secreto", t: "Mejor Atardecer", d: "La Ría de Alvor al atardecer es impresionante — reflejos dorados sobre el estuario. Ve por los Passadiços hacia las 19h (en verano). El Forte de Alvor con vista al mar es otra opción increíble." },
        { tag: "Vale la pena", t: "Silves Vale la Visita", d: "A 25 min. Castillo moro medieval y catedral gótica. El Festival Medieval en julio/agosto es un evento único en Europa. Reserva alojamiento en Silves ese fin de semana." },
        { tag: "Sabores", t: "Productos Regionales", d: "¡No te vayas sin probar el medronho! También: higos secos algarvios, almendra tostada y miel de brezo de Monchique. Mercado de Portimão los sábados por la mañana." },
      ],
    },
    footer: {
      tagline: "Tu refugio en el corazón de Mexilhoeira Grande. Casa con encanto y hospitalidad personal de Carlos & Rute Simões. Reserva directa, siempre al mejor precio.",
      contacts: "Contactos",
      address: "Dirección",
      rights: "Todos los derechos reservados",
      madeIn: "Hecho con ♥ en Mexilhoeira Grande, Algarve",
      followUs: "Síguenos",
      followTitle1: "Sigue la casa",
      followTitle2: "en Instagram & Facebook",
      followSubtitle: "Mira en primera mano los entresijos de la preparación, las novedades y el día a día en Mexilhoeira Grande. Escanea el QR con la cámara del móvil.",
    },
    whatsapp: { open: "Hablar por WhatsApp", title: "¡Hola! 👋", subtitle: "¿Cómo prefieres hablar con nosotros?", carlos: "Hablar con Carlos", rute: "Hablar con Rute", greeting: "¡Hola! Me interesa reservar MexiHome5." },
    about: {
      hero: { eyebrow: "Inicio › Sobre", title1: "Nuestra casa", title2: "& ubicación", subtitle: "Conoce MexiHome5, tus anfitriones Carlos & Rute, las playas, restaurantes y consejos secretos del Algarve." },
      story: {
        eyebrow: "Nuestra historia",
        welcome: "Bienvenidos al",
        body1: "Es un gran placer recibir a nuestros huéspedes en MexiHome5. Esta es vuestra casa durante la estancia — sentíos como en casa para explorar, descansar y descubrir todo lo que el Algarve tiene para ofrecer.",
        body2: "Situada en Rua Valeriano João da Glória, N° 5, en Mexilhoeira Grande, la casa combina el encanto algarvio tradicional con el confort moderno. A 10 minutos de Portimão, 12 de la Playa de Alvor y 20 de Lagos — tranquila para descansar, cerca de todo lo importante.",
        body3: "Cuando reservas directamente con nosotros, tienes el mejor precio garantizado, comunicación directa con los anfitriones y una experiencia personalizada que las plataformas no pueden dar.",
        metrics: [ { v: "6", l: "Huéspedes máx." }, { v: "2", l: "Habitaciones" }, { v: "1", l: "Baño" }, { v: "120m²", l: "Área aprox." } ],
        license: "Alojamiento Local",
      },
      hosts: {
        eyebrow: "Quién os recibe",
        title1: "Vuestros",
        title2: "anfitriones",
        cards: {
          carlos: { tag: "Anfitrión principal", desc: "Disponible para cualquier duda o emergencia. WhatsApp disponible." },
          rute: { tag: "Anfitriona", desc: "Contacto alternativo. WhatsApp disponible. Para check-in tardío y peticiones especiales." },
          email: { tag: "Email", desc: "Para reservas, presupuestos, check-in tardío o peticiones especiales.", cta: "Enviar email" },
          sos: { tag: "Emergencias", desc: "Emergencias generales en Portugal.", cta: "Llamar ahora" },
          hospital: { tag: "Hospital Portimão", desc: "Urgencias médicas · 24 horas · a 10 min de la casa.", cta: "Llamar ahora" },
          farmacia: { tag: "Farmacia", desc: "Mexilhoeira Grande · ~300m. Para urgencias menores." },
        },
      },
      map: { eyebrow: "Localización", title1: "Mexilhoeira Grande,", title2: "Algarve", addressLabel: "Dirección exacta", distancesLabel: "Distancias", openMap: "Abrir en Google Maps", walk: "a pie" },
    },
  },
  de: {
    nav: { gallery: "Galerie", amenities: "Ausstattung", neighborhood: "Umgebung", booking: "Buchung", about: "Über uns", reviews: "Bewertungen", cta: "Angebot anfragen" },
    availability: "Buchungskalender öffnet im Juli 2026 · Vorabbuchungen mit Vorrang willkommen",
    hero: {
      badge: "Lokale Unterkunft · Mexilhoeira Grande",
      title1: "Ihr Rückzugsort",
      title2: "an der Algarve",
      subtitle: "Charmantes Haus in Mexilhoeira Grande,",
      subtitle2: "10 Min. von Portimão und 20 Min. von Lagos.",
      address: "Rua Valeriano João da Glória, Nº 5 · Mexilhoeira Grande, 8500-132",
      pricetag: "Direktbuchung = bester Preis garantiert",
      cta: "Angebot anfragen",
      gallery: "Galerie ansehen",
    },
    hosts: { eyebrow: "Ihre Gastgeber:", names: "Carlos & Rute", description: "Verfügbar für jede Frage oder Notfall. WhatsApp verfügbar." },
    bannerPreco: {
      title: "Direkt buchen und sparen",
      subtitle: "Keine Provisionen. Hier immer der beste Preis, mit persönlicher Betreuung von Carlos & Rute.",
      bullets: ["Keine Servicegebühren", "Direkter Kontakt zu Gastgebern", "Volle Flexibilität", "Schnelle Antwort"],
    },
    amenities: {
      eyebrow: "Was das Haus bietet",
      title1: "Ausstattung für",
      title2: "den perfekten Urlaub",
      items: {
        jacuzzi: { t: "Whirlpool", d: "Privater Whirlpool im Patio mit beheizter Hydromassage. Ideal zum Entspannen am späten Nachmittag, nach dem Strand." },
        ac: { t: "Klimaanlage", d: "Fernbedienung im Schlafzimmer. Modi Kühl und Heizen. Beim Verlassen immer ausschalten." },
        wifi: { t: "High-Speed WLAN", d: "Netzwerk: MexiHome5_Guest — schnelle Verbindung im ganzen Haus." },
        tv: { t: "Smart TV", d: "Smart TV im Schlafzimmer mit Zugang zu Streaming-Plattformen. Fernbedienung am Nachttisch." },
        coffee: { t: "Kaffeemaschine", d: "Kapseln im oberen Schrank. Einschalten → grünes Licht → Kapsel einlegen → drücken." },
        kitchen: { t: "Voll ausgestattete Küche", d: "Komplette Küche. Coviran Supermarkt nur 80m entfernt für tägliche Einkäufe." },
        parking: { t: "Parkplatz", d: "Kostenlos auf der Straße direkt vor der Tür. Keine Sorgen bei der Ankunft." },
        checkout: { t: "Einfacher Check-out", d: "Check-out bis 11:00. Schlüssel im Tresor am Eingang. Spätes Auschecken mit Vorankündigung." },
        pets: { t: "Haustiere", d: "Mit vorheriger Genehmigung erlaubt. Bei Buchung immer angeben." },
      },
      rules: { title: "Hausregeln", items: ["🔇 Ruhe ab 22:00 Uhr", "🚭 Rauchen im Innenraum verboten", "👥 Nur registrierte Gäste übernachten", "🐾 Haustiere nur mit vorheriger Genehmigung"] },
      recycling: { title: "Recycling (Straße A)", items: ["Blau → Papier", "Gelb → Plastik/Metall", "Grün → Glas", "Schwarz → Restmüll"] },
    },
    gallery: { eyebrow: "Das Haus", title: "Rua Valeriano João da Glória,", title2: "Nº 5", cta: "Jetzt buchen", note: "Vorläufige Fotos der ersten Räume — vollständige Galerie verfügbar bei Eröffnung im Juli.", construction: "In Vorbereitung" },
    distances: { eyebrow: "Lage", title1: "Alles in Ihrer", title2: "Nähe", subtitle: "Vom Supermarkt zum Strand, von Bäckereien zu Restaurants — alles wenige Schritte oder Minuten entfernt." },
    neighborhood: { eyebrow: "Zu Fuß von der Tür", title1: "Mexilhoeira Grande", title2: "hat alles in der Nähe" },
    restaurants: {
      eyebrow: "Tipps von Carlos & Rute",
      title1: "Empfohlene",
      title2: "Restaurants",
      reservation: "Reservierung erforderlich",
      lunch: "Mittagessen",
      goodPrice: "Gutes Preis-Leistungs-Verhältnis",
    },
    booking: {
      eyebrow: "Direktbuchung",
      title1: "Angebot",
      title2: "anfragen",
      subtitle: "Füllen Sie das Formular aus und Carlos oder Rute antworten innerhalb von 24 Stunden mit einem personalisierten Preis für Ihren Aufenthalt.",
      highlights: [
        { t: "Bester Preis garantiert", d: "Keine Provisionen — sparen Sie bis zu 15% gegenüber Plattformen." },
        { t: "Sprechen Sie mit Carlos & Rute", d: "Direkter Kontakt zu den Gastgebern. Ohne Vermittler." },
        { t: "Check-out bis 11:00", d: "Späte Check-outs nach Absprache möglich." },
        { t: "Schnelle Antwort", d: "Carlos: 965 209 781 · Rute: 965 488 960 · WhatsApp ✓" },
      ],
      form: {
        title: "Angebotsanfrage",
        subtitle: "Unverbindlich · Antwort in <24h von Carlos oder Rute",
        dates: "Aufenthaltsdaten",
        datesPlaceholder: "Check-in → Check-out wählen",
        nightsHint: "Mindestens 3 Nächte · maximal 31",
        adults: "Personen",
        babies: "Babys (bis 3 Jahre)",
        maxAdults: "Maximal 6 Personen",
        maxBabies: "Maximal 2 Babys",
        name: "Name",
        namePlaceholder: "Ihr Name",
        email: "E-Mail",
        emailPlaceholder: "email@beispiel.com",
        message: "Nachricht (optional)",
        messagePlaceholder: "Haustiere, Sonderwünsche, Kommentare…",
        submit: "Anfrage senden",
        sending: "Wird gesendet…",
        select: "— auswählen —",
        adult: "Person", adults_p: "Personen", baby: "Baby", babies_p: "Babys", max: "(max.)",
      },
      toast: { needDates: "Bitte Check-in- und Check-out-Daten auswählen.", minNights: "Der Mindestaufenthalt beträgt 3 Nächte.", maxNights: "Der maximale Aufenthalt beträgt 31 Nächte.", needAdults: "Bitte Anzahl der Personen angeben.", needNameEmail: "Bitte Name und E-Mail eingeben.", success: "Anfrage gesendet! Carlos oder Rute antworten in <24h. 🙏", error: "Konnte nicht gesendet werden. Bitte erneut versuchen." },
    },
    reviews: { eyebrow: "Was Gäste sagen", title1: "Bewertungen zu", title2: "MexiHome5",
      empty: { title: "Die ersten Bewertungen kommen bald", body: "Das Haus öffnet im Juli 2026 — sei einer der ersten Gäste, die das Erlebnis leben und eine ehrliche Bewertung teilen. Keine gefälschten Kommentare: nur Echtes.", cta: "Ich möchte zu den Ersten gehören" }
    },
    embreve: {
      badge: "Bald · Juli 2026",
      title1: "Das Haus wird mit",
      title2: "Liebe vorbereitet",
      subtitle: "Wir setzen die letzten Akzente, um die ersten Gäste im Juli 2026 zu empfangen. Reservieren Sie Ihre Daten vorrangig — vielen Dank für Ihre Geduld.",
      hint: "Vorabbuchungen willkommen · Antwort in <24h",
      cta: "Mit Vorrang reservieren",
      days: "Tage", hours: "Std.", minutes: "Min", seconds: "Sek"
    },
    segredos: {
      eyebrow: "Von Carlos & Rute",
      title1: "Lokale",
      title2: "Geheimnisse",
      subtitle: "Kleine Freuden und geheime Orte, die jeden Aufenthalt einzigartig machen — und einige Überraschungen, die noch kommen.",
      items: [
        { tag: "Die Überraschung enthüllt", t: "Whirlpool im Patio", d: "Die Überraschung, die wir vorbereitet haben, ist endlich da. Privater Whirlpool im Patio, beheiztes Wasser mit Hydromassage — perfekt, um den Tag unter dem Himmel der Algarve ausklingen zu lassen, in aller Ruhe und Privatsphäre." },
        { tag: "Geheimtipp", t: "Schönster Sonnenuntergang", d: "Die Alvor-Mündung in der Dämmerung ist atemberaubend — goldene Reflexe über dem Wasser. Gehen Sie gegen 19 Uhr (im Sommer) auf die Passadiços. Das Forte de Alvor mit Meerblick ist eine weitere großartige Option." },
        { tag: "Lohnt sich", t: "Silves Lohnt sich", d: "25 Min. entfernt. Maurische mittelalterliche Burg und gotische Kathedrale. Das Mittelalterfest im Juli/August ist eine einzigartige Veranstaltung in Europa. Buchen Sie ein Quartier in Silves für dieses Wochenende." },
        { tag: "Aromen", t: "Regionale Produkte", d: "Probieren Sie unbedingt Medronho! Auch: Algarve-Trockenfeigen, geröstete Mandeln und Heidehonig aus Monchique. Markt von Portimão samstags morgens." },
      ],
    },
    footer: {
      tagline: "Ihr Rückzugsort im Herzen von Mexilhoeira Grande. Charmantes Haus mit der persönlichen Gastfreundschaft von Carlos & Rute Simões. Direktbuchung, immer zum besten Preis.",
      contacts: "Kontakt",
      address: "Adresse",
      rights: "Alle Rechte vorbehalten",
      madeIn: "Mit ♥ in Mexilhoeira Grande, Algarve gemacht",
      followUs: "Folgen Sie uns",
      followTitle1: "Folgen Sie dem Haus",
      followTitle2: "auf Instagram & Facebook",
      followSubtitle: "Sehen Sie Behind-the-Scenes der Vorbereitung, Neuigkeiten und Alltag in Mexilhoeira Grande. Scannen Sie den QR-Code mit Ihrer Handy-Kamera.",
    },
    whatsapp: { open: "WhatsApp-Chat", title: "Hallo! 👋", subtitle: "Wie möchten Sie uns kontaktieren?", carlos: "Mit Carlos sprechen", rute: "Mit Rute sprechen", greeting: "Hallo! Ich interessiere mich für eine Buchung im MexiHome5." },
    about: {
      hero: { eyebrow: "Start › Über uns", title1: "Unser Haus", title2: "& Lage", subtitle: "Lernen Sie MexiHome5, Ihre Gastgeber Carlos & Rute, die Strände, Restaurants und geheime Tipps der Algarve kennen." },
      story: {
        eyebrow: "Unsere Geschichte",
        welcome: "Willkommen im",
        body1: "Mit großer Freude empfangen wir unsere Gäste im MexiHome5. Dies ist Ihr Zuhause während Ihres Aufenthalts — fühlen Sie sich frei zu erkunden, zu entspannen und alles zu entdecken, was die Algarve zu bieten hat.",
        body2: "Gelegen in der Rua Valeriano João da Glória, Nº 5, in Mexilhoeira Grande, verbindet das Haus traditionellen Algarve-Charme mit modernem Komfort. 10 Minuten von Portimão, 12 vom Strand von Alvor und 20 von Lagos — ruhig zum Ausruhen, nah an allem, was wichtig ist.",
        body3: "Wenn Sie direkt bei uns buchen, haben Sie den besten Preis garantiert, direkte Kommunikation mit den Gastgebern und ein personalisiertes Erlebnis, das Plattformen nicht bieten können.",
        metrics: [ { v: "6", l: "Gäste max." }, { v: "2", l: "Schlafzimmer" }, { v: "1", l: "Bad" }, { v: "120m²", l: "Fläche ca." } ],
        license: "Lokale Unterkunft",
      },
      hosts: {
        eyebrow: "Wer Sie empfängt",
        title1: "Ihre",
        title2: "Gastgeber",
        cards: {
          carlos: { tag: "Hauptgastgeber", desc: "Verfügbar für jede Frage oder jeden Notfall. WhatsApp verfügbar." },
          rute: { tag: "Gastgeberin", desc: "Alternativer Kontakt. WhatsApp verfügbar. Für späten Check-in und Sonderwünsche." },
          email: { tag: "E-Mail", desc: "Für Buchungen, Angebote, späten Check-in oder Sonderwünsche.", cta: "E-Mail senden" },
          sos: { tag: "Notfälle", desc: "Allgemeine Notfälle in Portugal.", cta: "Jetzt anrufen" },
          hospital: { tag: "Krankenhaus Portimão", desc: "Medizinische Notfälle · 24 Stunden · 10 Min. vom Haus.", cta: "Jetzt anrufen" },
          farmacia: { tag: "Apotheke", desc: "Mexilhoeira Grande · ~300m. Für kleinere Notfälle." },
        },
      },
      map: { eyebrow: "Lage", title1: "Mexilhoeira Grande,", title2: "Algarve", addressLabel: "Genaue Adresse", distancesLabel: "Entfernungen", openMap: "In Google Maps öffnen", walk: "zu Fuß" },
    },
  },
};
